import React from "react";
import { shouldRenderDiv, addHeaderTagIfMissing } from "../buyingGuideHelpers";
import { BuyingGuideSection } from "../Types/BuyingGuideSection";
import BuyingGuideSectionTypes from "../Types/BuyingGuideSectionTypes";

export default function BuyingGuideTextImage({
  section,
  defaultHeaderTag,
}: {
  section: BuyingGuideSection;
  defaultHeaderTag: string;
}) {
  const content = section?.contents[0] ?? undefined;

  return (
    <div
      className={`guide-section textimage-${
        section.type === BuyingGuideSectionTypes.TextImageLeft
          ? "left"
          : "right"
      }-template`}
    >
      <div className="flex-container">
        {content !== undefined && content?.imageUrl.length > 0 && (
          <div className="template-image">
            <img src={content.imageUrl} alt="Restaurant Equipment" />
          </div>
        )}
        <div className="template-text">
          {shouldRenderDiv(section.heading) ? (
            <div
              className="item-header"
              dangerouslySetInnerHTML={{
                __html: addHeaderTagIfMissing(
                  section.heading,
                  defaultHeaderTag,
                ),
              }}
            />
          ) : (
            <div
              className="item-header"
              dangerouslySetInnerHTML={{
                __html: content?.heading ?? "",
              }}
            />
          )}
          {shouldRenderDiv(content?.htmlContent) && (
            <div
              dangerouslySetInnerHTML={{
                __html: content?.htmlContent ?? "",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
